<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <performance>
        </performance> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import Performance from './todo-performance'
export default {
    components: {
       Performance
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-performance/base-performance.vue